import "./Publications.scss";
import { useTranslation } from "react-i18next";

const Publications = ()=> {
    const {t} = useTranslation();
    const publicationsData = t("publications", {returnObjects: true});
    const handleClick = (targetUrl) => {
      window.open(targetUrl, "_bank");
    };
    return (
      <section className="skills">
        <div className="skills__container">
          <div className="skills__title">
            <h3>{t("publicationsTitle.title")}</h3>
            <label>{t("publicationsTitle.label")}</label>
          </div>
          <div className="skills__content">
            {publicationsData.map((pub, idx) => (
              <article
                key={idx}
                className="skills__description"
                onClick={() => handleClick(pub.targetUrl)}
              >
                <h4 className="skills__subtitle">{pub.title}</h4>
                <p>{pub.content}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    );
}

export default Publications;